import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgReload = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.79547 4.66675C3.88502 6.25556 2.66675 8.65178 2.66675 11.3334C2.66675 16.1198 6.54697 20 11.3334 20C16.1198 20 20 16.1198 20 11.3334C20 8.94434 19.0329 6.79297 17.6191 5.23926L16.1399 6.58526C17.2509 7.80634 18 9.48829 18 11.3334C18 15.0153 15.0153 18 11.3334 18C7.65153 18 4.66675 15.0152 4.66675 11.3334C4.66675 9.18352 5.684 7.27035 7.2666 6.05027L7.2666 9.7334H9.2666L9.2666 2.66675H2.19995V4.66675L5.79547 4.66675Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgReload);

export default ForwardRef;
